import React, { useEffect, useState } from 'react'
import { Dialog, Button } from '@material-ui/core'

function AmountModal(props) {
    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')
    const [amount, setAmount] = useState()

    useEffect(() => {
        setTitle(props.title)
        setMessage(props.message)
    }, [])

    const onCloseScreen = () => {
        props.onCloseFunc()
    }

    return (
        <Dialog open={true} onClose={onCloseScreen} maxWidth="sm" fullWidth aria-labelledby="confirmationDialog" style={{ borderRadius: 16 }}>
            <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 24, paddingRight: 16, paddingLeft: 16, paddingBottom: 8 }}>
                <p className="PrimaryText" style={{ textAlign: 'center', color: 'white' }}>{title}</p>
                <p className="ThirdLightText" style={{ textAlign: 'center', color: '#eeeeee', marginLeft: 16, marginTop: 6 }}>
                    {message}
                </p>
                <input
                    style={{ marginTop: 16 }}
                    type="number"
                    name="amount"
                    placeholder="مبلغ (تومان)"
                    value={amount}
                    onChange={(e)=>setAmount(e.target.value)}
                    className="custom-input radius10 ease"
                />
                <div style={{ display: 'flex', height: 40, alignItems: 'center', textAlign: 'left', paddingBottom: 8, direction: 'ltr', marginTop: 12 }}>
                    <Button fullWidth className="Red-background rounded" onClick={() => props.onCloseFunc()} >
                        انصراف
                    </Button>
                    <div style={{ width: 16 }} />
                    <Button fullWidth className="Green-background rounded" onClick={() => props.onSelect(amount)} style={{ color: 'white' }}>
                        اعمال
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default AmountModal
